import { postRequest } from "../apiRequest";
import { apiRoutes } from "../Constants/ApiRoutes";


export const SubmitIssueService = (payload) => {
    return postRequest(apiRoutes.submitQuery, payload);
};